export default {
  name: 'ExamDetailsUrgencyAlertHistory',
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('pt-BR')
    }
  }
}
